import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModulosSelecaoService {
  private idSelecionadoSubject = new BehaviorSubject<number | null>(null);
  idSelecionado$ = this.idSelecionadoSubject.asObservable();

  private modulosDisponiveisSubject = new BehaviorSubject<
    { [key: number]: boolean } | any[]
  >({});
  modulosDisponiveis$ = this.modulosDisponiveisSubject.asObservable();

  private temAcessoModuloSubject = new BehaviorSubject<boolean>(true);
  temAcessoModulo$ = this.temAcessoModuloSubject.asObservable();

  constructor() {}

  setIdSelecionado(id: number | null): void {
    if (id === null) {
      console.warn('Tentativa de redefinir ID para null ignorada.');
      return;
    }

    const currentId = this.idSelecionadoSubject.getValue();
    if (currentId === id) {
      console.warn('ID já está selecionado:', id);
      return;
    }

    this.idSelecionadoSubject.next(id);
  }

  getIdSelecionado(): number | null {
    return this.idSelecionadoSubject.getValue();
  }

  setModulosDisponiveis(modulos: { [key: number]: boolean } | any[]): void {
    this.modulosDisponiveisSubject.next(modulos);
  }

  getModulosDisponiveis(): { [key: number]: boolean } | any[] {
    const modulos = this.modulosDisponiveisSubject.getValue();
    return modulos;
  }

  setTemAcessoModulo(valor: boolean): void {
    this.temAcessoModuloSubject.next(valor);
  }

  getTemAcessoModulo(): boolean {
    return this.temAcessoModuloSubject.getValue();
  }
}
